var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-size" }, [
    _c("div", { staticClass: "fix-top" }, [
      _c("div", { staticClass: "nav-box" }, [
        _c("ul", [
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/" })
                  }
                }
              },
              [_vm._v("主页")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/product" })
                  }
                }
              },
              [_vm._v("产品列表")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/news" })
                  }
                }
              },
              [_vm._v("理财资讯")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/search" })
                  }
                }
              },
              [_vm._v("搜索")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "full-size" }, [
        _c("div", { staticClass: "ui layout vertical" }, [
          _c("div", { staticClass: "main-search" }, [
            _c("div", { staticClass: "search-box" }, [
              _c("i", { staticClass: "icon-search" }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchInput,
                    expression: "searchInput"
                  }
                ],
                staticClass: "text",
                attrs: {
                  type: "text",
                  placeholder: "请输入产品代码/名称/首字母",
                  id: "search-input",
                  autocomplete: "off"
                },
                domProps: { value: _vm.searchInput },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.keydown.apply(null, arguments)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchInput = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.searchInput.length > 0
                ? _c("i", {
                    staticClass: "icon-clear",
                    on: {
                      click: function($event) {
                        _vm.searchInput = ""
                        _vm.resetSearch()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "search-btn",
                  attrs: { href: "javascript:void(0);" },
                  on: {
                    click: function($event) {
                      _vm.resetSearch()
                      _vm.toSearch()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row-1 search-list" },
            [
              !_vm.isEmpty
                ? [
                    _vm.companyArr.length > 0
                      ? _c("div", { staticClass: "part" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "inner-box" },
                            [
                              _vm.moreType == "com"
                                ? _vm._l(
                                    _vm.companyArr.slice(0, _vm.numper),
                                    function(list, index) {
                                      return _c("dl", { key: index }, [
                                        _c("dt", [
                                          _c("strong", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.highlight(
                                                  list.com_name,
                                                  _vm.searchInput
                                                )
                                              )
                                            }
                                          })
                                        ])
                                      ])
                                    }
                                  )
                                : _vm._l(_vm.companyArr.slice(0, 5), function(
                                    list,
                                    index
                                  ) {
                                    return _c("dl", { key: index }, [
                                      _c("dt", [
                                        _c("strong", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.highlight(
                                                list.com_name,
                                                _vm.searchInput
                                              )
                                            )
                                          }
                                        })
                                      ])
                                    ])
                                  })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          (_vm.companyArr.length > 5 &&
                            _vm.moreType != "com") ||
                          (_vm.moreType == "com" &&
                            _vm.companyArr.length > _vm.numper)
                            ? _c(
                                "div",
                                {
                                  staticClass: "more",
                                  on: {
                                    click: function($event) {
                                      return _vm.goMore("com")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    { attrs: { href: "javascript:void(0);" } },
                                    [_vm._v("查看更多")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.searchArr, function(item, key) {
                      return _c("div", { key: key, staticClass: "part" }, [
                        item.data.length > 0
                          ? _c("div", { staticClass: "title-box" }, [
                              _c("h5", [_vm._v(_vm._s(item.text))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.data.length > 0
                          ? _c(
                              "div",
                              { staticClass: "inner-box" },
                              [
                                _vm._l(item.data, function(list, index) {
                                  return item.id == "1fund"
                                    ? _c(
                                        "dl",
                                        {
                                          key: index,
                                          on: {
                                            click: function($event) {
                                              return _vm.goRouter(
                                                "fund",
                                                list.cpdm
                                              )
                                            }
                                          }
                                        },
                                        [
                                          list.cpfl == "1"
                                            ? _c("dt", [
                                                _c("strong", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.highlight(
                                                        list.cpmc,
                                                        _vm.searchInput
                                                      )
                                                    )
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(list.cpdm))
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          list.cpfl == "1"
                                            ? _c("dd", [
                                                _vm._v(
                                                  "净值：" +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.bn,
                                                          "--",
                                                          4,
                                                          "1",
                                                          ""
                                                        ),
                                                        4
                                                      )
                                                    ) +
                                                    "元"
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          list.cpfl == "1"
                                            ? _c("dd", [
                                                _c("span", [
                                                  _vm._v("近一月涨幅:"),
                                                  _c("em", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.syl,
                                                          "--",
                                                          2,
                                                          1,
                                                          "%"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          list.cpfl == "0"
                                            ? _c("dt", [
                                                _c("strong", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.highlight(
                                                        list.cpmc,
                                                        _vm.searchInput
                                                      )
                                                    )
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(list.cpdm))
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          list.cpfl == "0"
                                            ? _c("dd", [
                                                _vm._v(
                                                  "万份收益：" +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.sylsx,
                                                          "--",
                                                          4,
                                                          "1",
                                                          ""
                                                        ),
                                                        4
                                                      )
                                                    )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          list.cpfl == "0"
                                            ? _c("dd", [
                                                _c("span", [
                                                  _vm._v("七日年化:"),
                                                  _c("em", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.sylxx,
                                                          "--",
                                                          2,
                                                          1,
                                                          "%"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ])
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm._l(item.data, function(list, index) {
                                  return item.id == "4zg"
                                    ? _c(
                                        "dl",
                                        {
                                          key: index,
                                          on: {
                                            click: function($event) {
                                              return _vm.goRouter(
                                                "otc",
                                                list.cpid
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("dt", [
                                            _c("strong", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(
                                                    list.cpmc,
                                                    _vm.searchInput
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "code",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(
                                                    list.cpdm,
                                                    _vm.searchInput
                                                  )
                                                )
                                              }
                                            })
                                          ]),
                                          _vm._v(" "),
                                          _c("dd", [
                                            list.es_tycpfl_zg ==
                                            _vm.constants.ES_TYCPFL_ZG.JZ
                                              ? _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [_vm._v("单位净值")]
                                                )
                                              : list.es_tycpfl_zg ==
                                                  _vm.constants.ES_TYCPFL_ZG
                                                    .LC && "1" == list.sylsx
                                              ? _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [_vm._v("本周结算")]
                                                )
                                              : list.es_tycpfl_zg ==
                                                  _vm.constants.ES_TYCPFL_ZG
                                                    .LC && "1" != list.sylsx
                                              ? _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [_vm._v("业绩比较基准")]
                                                )
                                              : _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [_vm._v("近一月涨幅")]
                                                ),
                                            _vm._v(" "),
                                            list.es_tycpfl_zg ==
                                            _vm.constants.ES_TYCPFL_ZG.JZ
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      list.syl >= 0
                                                        ? "ared"
                                                        : "agreen"
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.syl,
                                                          "--",
                                                          4,
                                                          1,
                                                          ""
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : list.es_tycpfl_zg ==
                                                _vm.constants.ES_TYCPFL_ZG.LC
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      list.syl >= 0
                                                        ? "ared"
                                                        : "agreen"
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.syl,
                                                          "--",
                                                          3,
                                                          1,
                                                          "%"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      list.syl >= 0
                                                        ? "ared"
                                                        : "agreen"
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "parseFloatFormat"
                                                        )(
                                                          list.syl,
                                                          "--",
                                                          2,
                                                          1,
                                                          "%"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm._l(item.data, function(list, index) {
                                  return item.id == "2lcb" ||
                                    item.id == "3yyc" ||
                                    item.id == "8other" ||
                                    item.id == "5nxb" ||
                                    item.id == "6hjb"
                                    ? _c(
                                        "ul",
                                        {
                                          key: index,
                                          on: {
                                            click: function($event) {
                                              return _vm.goRouter(
                                                "otc",
                                                list.cpid
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("li", [
                                            _c("strong", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(
                                                    list.cpmc,
                                                    _vm.searchInput
                                                  )
                                                )
                                              }
                                            }),
                                            _c("span", {
                                              staticClass: "code",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(
                                                    list.cpdm,
                                                    _vm.searchInput
                                                  )
                                                )
                                              }
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "stat" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("statusFormat")(
                                                      list.product_status
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm._l(item.data, function(list, index) {
                                  return item.id == "7sm"
                                    ? _c(
                                        "ul",
                                        {
                                          key: index,
                                          on: {
                                            click: function($event) {
                                              return _vm.goRouter(
                                                "otc",
                                                list.cpid
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("li", [
                                            _c("strong", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(
                                                    list.cpmc,
                                                    _vm.searchInput
                                                  )
                                                )
                                              }
                                            }),
                                            _c("span", {
                                              staticClass: "code",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(
                                                    list.cpdm,
                                                    _vm.searchInput
                                                  )
                                                )
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (item.tempdata.length > 5 &&
                          !(_vm.moreType.indexOf(item.id) > -1)) ||
                        (_vm.moreType.indexOf(item.id) > -1 &&
                          item.currpage < item.maxpage)
                          ? _c(
                              "div",
                              {
                                staticClass: "more",
                                on: {
                                  click: function($event) {
                                    return _vm.goMore(item.id)
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0);" } },
                                  [_vm._v("查看更多")]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    })
                  ]
                : [_vm._m(1)]
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-box" }, [
      _c("h5", [_vm._v("基金公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("暂无数据")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-625e212c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625e212c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search.vue
// module id = null
// module chunks = 